<div data-at-limited-search *ngIf="noResults || isLimited" class="flex flex-col">
  <div class="no-results-wrapper flex flex-row justify-center items-center lt-lg:flex-auto">
    <div class="no-results flex flex-col gap-[15px] flex-1">
      <div data-at-no-results *ngIf="noResults" class="title flex-1">
        {{ '+INSTALLATIONS.INSTALLATIONS.INSTALLATION_LIST.NO_RESULTS' | translate }}
        <strong>"<ng-content></ng-content>"</strong>
      </div>
    </div>
  </div>
</div>
